import React, { useState } from 'react';
import SimpleSynonyms from './SimpleSynonyms';

function ResultDisplay({ results }) {
  const [savedWords, setSavedWords] = useState(() => {
    const saved = localStorage.getItem('savedWords');
    return saved ? JSON.parse(saved) : [];
  });

  const saveWord = (word) => {
    const newSaved = [...savedWords, word];
    setSavedWords(newSaved);
    localStorage.setItem('savedWords', JSON.stringify(newSaved));
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        Results
      </h2>
      
      {results.summary && (
        <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-blue-800">{results.summary}</p>
        </div>
      )}

      {/* Simple Synonyms - Show prominently */}
      {results.groups?.filter(group => group.name === "Simple Synonyms" && group.items && group.items.length > 0).map((group, groupIndex) => (
        <SimpleSynonyms key={`simple-synonyms-${groupIndex}`} items={group.items} />
      ))}

      {/* Other Result Groups */}
      {results.groups?.filter(group => group.name !== "Simple Synonyms" && group.items && group.items.length > 0).map((group, groupIndex) => (
        <div key={groupIndex} className="mb-8">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            {group.name}
          </h3>
          
          <div className="grid gap-4">
            {group.items?.map((item, itemIndex) => (
              <div
                key={itemIndex}
                className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
              >
                <div className="flex justify-between items-start mb-2">
                  <h4 className="text-lg font-medium text-gray-900">
                    {item.word}
                  </h4>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-blue-600">
                      {item.score}
                    </span>
                    <div className="flex gap-2">
                      <button
                        onClick={() => copyToClipboard(item.word)}
                        className="text-sm px-2 py-1 bg-gray-100 hover:bg-gray-200 rounded"
                      >
                        Copy
                      </button>
                      <button
                        onClick={() => saveWord(item)}
                        className="text-sm px-2 py-1 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
                
                <p className="text-gray-600 text-sm mb-2">
                  {item.reason}
                </p>
                
                {item.tags && (
                  <div className="flex flex-wrap gap-1">
                    {item.tags.map((tag, tagIndex) => (
                      <span
                        key={tagIndex}
                        className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}

      {savedWords.length > 0 && (
        <div className="mt-8 pt-8 border-t border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Saved Words
          </h3>
          <div className="flex flex-wrap gap-2">
            {savedWords.map((word, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-green-100 text-green-800 rounded-full"
              >
                {word.word}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ResultDisplay;
